import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"

const defaultRedirectForRole = role => {
  if (role === "AD" || role === "SA") return "/admin/dashboard"
  if (["TN", "PPTN", "EXP"].includes(role)) return "/tn/dashboard"
  return "/"
}

export default function ({ children, allowedRoles }) {
  const { isLoggedIn, userType } = useSelector(state => state.auth)

  if (!isLoggedIn) {
    // user is not authenticated
    return <Navigate replace to={"/"} />
  }

  if (allowedRoles && !allowedRoles.includes(userType)) {
    return <Navigate replace to={defaultRedirectForRole(userType)} />
  }

  return children
}
